import React, { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../Sidebar";
const Navbar = () => {
   const [open, setOpen] =useState(false)

   const toggleSidebar = () => {
    console.log("click")
    setOpen((prev) => !prev);
  };

  return (
    <div>
    <nav className=" bg-black fixed z-[99] w-full">
    <div className=" flex justify-between py-2 container">
    <div className="flex items-center">
      
    <img onClick={toggleSidebar} src="	https://9wicket.pro/images/menu-bar.png" width={30} className=" cursor-pointer" alt="" /> 
      
    <div>
    <img src="new_img/logo.png" alt="" width={150} />
    </div>
    
    </div>
        <div className=" flex text-header2 text-[16px] font-medium items-center gap-3">
        <div className="icons  flex flex-col items-center"> 
          <div>
        <img width={18} src="/new_img/app1.png" alt="" />
          </div>
          <div>

        <span className=" text-center">App</span>
          </div>
          </div> 
        <div className="icons flex flex-col items-center">
          <div>
        <img width={20} src="https://9wicket.pro/images/comment.png" className=" " alt="" />
          </div>
          <div>
        <span className=" text-center">Help</span>
          </div>
        </div>
       </div>
       </div>
       </nav>
  <Sidebar open={open} toggleSidebar={toggleSidebar} /> 
       </div>
  
  );
};

export default Navbar;






// const OldNav = ()=>{
//   const [color, setColor] = useState(false);
  
//   const chnageColor = () => {
//     setColor(true);
//   };
//   return <nav className="navgation display_none">
//     <ul className="navList flex">
//           <div className="col-lg-6 d-flex items-center">
//             <Link className={`nav_item ${color ? "bg-red-500" : ""}`} to={"/"}>
//               Home
//             </Link>
//             <Link className="nav_item" to={"/in-play"}>
//               In-Play
//             </Link>
//             <Link className="nav_item" to={"/multi-markets"}>
//               Multi Markets
//             </Link>
//             <Link className="nav_item" to={"/cricket"}>
//               <div className="live_headtitle">
//                 <div className="bg-white h-full flex items-center justify-center w-[20px]">
//                   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
//                     <g fill="rgb(255,0,0)" fill-rule="evenodd">
//                       <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
//                       <circle cx="6.8" cy="4.4" r="1.6" />
//                     </g>
//                   </svg>
//                 </div>

//                 <span className=" text-[11px]  ">4</span>
//               </div>
//               Cricket
//             </Link>
//             <Link className="nav_item" to={"/soccer"}>
//               <div className="live_headtitle">
//                 <div className="bg-white h-full flex items-center justify-center w-[20px]">
//                   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
//                     <g fill="rgb(255,0,0)" fill-rule="evenodd">
//                       <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
//                       <circle cx="6.8" cy="4.4" r="1.6" />
//                     </g>
//                   </svg>
//                 </div>

//                 <span className=" text-[11px]  ">3</span>
//               </div>
//               Soccer
//             </Link>
//             <Link className="nav_item" to={"/tennis"}>
//               <div className="live_headtitle">
//                 <div className="bg-white h-full flex items-center justify-center w-[20px]">
//                   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
//                     <g fill="rgb(255,0,0)" fill-rule="evenodd">
//                       <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
//                       <circle cx="6.8" cy="4.4" r="1.6" />
//                     </g>
//                   </svg>
//                 </div>

//                 <span className=" text-[11px]  ">11</span>
//               </div>
//               Tennis{" "}
//             </Link>
//           </div>
//           <div className="col-lg-5 items-center d-flex justify-content-end">
//             <span className="time_zone mx-2">Time Zone :</span>{" "}
//             <li className="setting">GMT+5:30</li>
//             <li className="setting flex items-center">
//               settings
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="12"
//                 height="12"
//                 className="ml-2"
//               >
//                 <path
//                   d="M6 8.106c.385 0 .745-.096 1.081-.289.336-.192.602-.45.8-.771a2.002 2.002 0 0 0 0-2.099 2.19 2.19 0 0 0-.8-.779A2.139 2.139 0 0 0 6 3.88c-.385 0-.743.096-1.074.288-.33.193-.594.452-.792.78a2.002 2.002 0 0 0 0 2.098c.198.322.462.579.792.771.331.193.689.289 1.074.289zm4.605-1.515l1.288.981c.06.048.094.11.104.188a.333.333 0 0 1-.044.216l-1.244 2.077a.269.269 0 0 1-.156.13.336.336 0 0 1-.214-.015l-1.526-.591c-.394.279-.745.476-1.05.591L7.54 11.74a.364.364 0 0 1-.111.188.272.272 0 0 1-.185.072H4.756a.29.29 0 0 1-.281-.26l-.237-1.572A3.752 3.752 0 0 1 3.2 9.577l-1.54.591c-.158.068-.28.03-.37-.115L.047 7.976a.333.333 0 0 1-.044-.216.278.278 0 0 1 .104-.188l1.303-.98A4.395 4.395 0 0 1 1.38 6c0-.26.01-.457.03-.591L.107 4.428a.278.278 0 0 1-.104-.188.333.333 0 0 1 .044-.216l1.244-2.077c.09-.144.212-.183.37-.115l1.54.591c.356-.26.701-.457 1.037-.591L4.475.26A.29.29 0 0 1 4.756 0h2.488c.069 0 .13.024.185.072.054.048.091.11.111.188l.222 1.572a3.87 3.87 0 0 1 1.051.591l1.526-.591a.336.336 0 0 1 .214-.015c.064.02.116.063.156.13l1.244 2.077c.04.067.054.14.044.216a.278.278 0 0 1-.104.188l-1.288.98c.02.135.03.332.03.592 0 .26-.01.457-.03.591z"
//                   fill="#222"
//                   fill-rule="evenodd"
//                 />
//               </svg>
//             </li>
//           </div>
//         </ul>
//   </nav>
// }